export default "__VITE_ASSET__DusB8E_A__"